import React, { useState } from 'react';
import DownloadableReportTable from '../DownloadableReportTable';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';

const UserReportsTab = () => {
  const APP_CONFIG = useService<SharedAngular.APP_CONFIG>('APP_CONFIG');
  const momentService = useService<Moment>('momentService');

  const [userFromDate, setUserFromDate] = useState<Date>(
    momentService().subtract('months', 1).toDate()
  );
  const [userToDate, setUserToDate] = useState<Date>(momentService().toDate());

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const reports = [
    {
      name: 'Users Report',
      description: 'Basic information about users and logins.',
      url: APP_CONFIG.apiBaseUrl + 'reports/users/current/csv',
      parameters: {
        userTimeZone: userTimeZone,
        fromDate: momentService(userFromDate).format(
          'YYYY-MM-DDTHH:mm:ss.SSSZ'
        ),
        toDate: momentService(userToDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      }
    }
  ];
  return (
    <>
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <div className="user-reports">
        <div className="user-reports-toolbar">
          <DatePicker
            format={'dd/MM/yyyy'}
            value={userFromDate}
            onChange={(event) => setUserFromDate(event.value)}
          />
          <span className="date-spacer"> To </span>
          <DatePicker
            format={'dd/MM/yyyy'}
            value={userToDate}
            onChange={(event) => setUserToDate(event.value)}
          />
        </div>
        <DownloadableReportTable reports={reports} />
      </div>
    </>
  );
};

export default UserReportsTab;
